import React, { useEffect, useState } from 'react';
import { getGradingDetailsByStudentId } from '../../Utils/apiServices';
import { withRouter } from 'react-router-dom';
import { Newtable } from '../../Components/NewTablecomponents/NewTablecomponent';
import KenLoader from '../../Components/KenLoader';
import KenGrid from '../../global_components/KenGrid';
import TabPanel from './TabPanel';
import KenCard from '../../global_components/KenCard';
import {
  Grid,
  AppBar,
  makeStyles,
  Box,
  Toolbar,
  Typography,
  Tab,
  Tabs,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Paper,
} from '@material-ui/core';
import { AiFillCaretRight, AiFillCaretDown } from 'react-icons/ai';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

function StudentReport(props) {
  const useStyles = makeStyles((theme) => ({
    breadCrumbWrapper: {
      margin: '15px 0',
    },
    header: {
      background: '#ffffff',
      color: theme.palette.KenColors.primary,
      marginTop: '20px',
    },
    title: {
      fontSize: 18,
      fontWeight: 600,
    },
    holidayButton: {
      textTransform: 'none',
      fontWeight: 'bold',
      marginRight: '5px',
    },
    fitlerButton: {
      textTransform: 'none',
      fontWeight: 'bold',
    },
    sortingSection: {
      display: 'grid',
      gap: '10px',
      gridTemplateColumns: 'repeat(7, 1fr)',
    },
    mainActions: {
      textAlign: 'right',
    },
    popOverHeading: {
      width: '100%',
      fontSize: '14px',
      fontWeight: '400',
      color: '#02195E',
    },
    tableBodyStyle: {
      fontSize: '12px',
      color: '#7A869A',
    },
    tableBodyStyleIgnoreHoliday: {
      fontSize: '12px',
      color: '#7A869A',
      padding: '0px',
    },
    textInputFieldDropDown: {
      background: 'transparent',
      borderRadius: '4px',
      color: '#000',
    },
    textInputField: {
      background: 'transparent',
      borderRadius: '4px',
      color: '#000',
    },
    kenDateTimePickerColor: {
      backgroundColor: '#fff',
    },
    tabs: {
      '& .MuiPaper-root': {
        padding: '0px',
        backgroundColor: 'red',
      },
    },
  }));

  const classes = useStyles();

  const { studentId } = props?.location?.state;
  const [data, setData] = React.useState([]);
  console.log(studentId);
  const [loading, setLoading] = React.useState(false);

  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    console.log('index', index);
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  // useEffect(() => {
  //   setLoading(true)
  //   getGradingDetailsByStudentId(studentId).then((res) => {
  //     console.log(res);
  //     setData(res);
  //     setLoading(false)
  //   })
  //     .catch((err) => {
  //       setLoading(true)
  //       console.log(err);
  //     })
  // }, [])

  // const columns = React.useMemo(
  //   () => [

  //     {
  //       // Make an expander cell
  //       Header: () => null, // No header
  //       id: 'expander', // It needs an ID
  //       Cell: ({ row }) => (
  //           // Use Cell to render an expander for each row.
  //           // We can use the getToggleRowExpandedProps prop-getter
  //           // to build the expander.
  //           <span {...row.getToggleRowExpandedProps()}>
  //               {row.isExpanded ? <AiFillCaretDown /> : <AiFillCaretRight />}
  //           </span>
  //       ),
  //   },
  //     {
  //       Header: 'Subject',
  //       accessor: 'subjectName',
  //     },
  //     {
  //       Header: 'Subject Code',
  //       accessor: 'subjectcode',
  //     },
  //     {
  //       Header: 'Course Credits',
  //       accessor: 'courseCredits',
  //     },
  //     {
  //       Header: 'Max',
  //       accessor: 'maximumMarks',
  //     },
  //     {
  //       Header: 'Obtained',
  //       accessor: 'marksObtained',
  //     },
  //     {
  //       Header: 'Percentage',
  //       accessor: 'percentage',
  //     },
  //     {
  //       Header: 'Grade',
  //       accessor: 'calculatedLetterGrade',
  //     },
  //     {
  //       Header: 'Final Grade',
  //       accessor: 'finalLetterGrade',
  //     },
  //     {
  //       Header: 'Status',
  //       accessor: 'passFailStatus',
  //     },
  //   ],
  //   []
  // );

  // const renderComponents= React.useCallback((({row})=>(
  //   <ComponentsMarksTable data={row.original}/>
  // )),[])

  return (
    <div>
      {loading && <KenLoader />}
      {/* <Typography>Students Marks Report</Typography>
       
       
       <Newtable
        columns={columns}
        data={data}
        /> */}
      {/* <Box sx={{ width: '100%' }}>
        <div position="static" elevation={0} className={classes.header}>
          <Toolbar style={{ minHeight: '45px' }}>
            <Typography className={classes.title}>Students Marks Report</Typography>
          </Toolbar>
        </div>
        <Box className={classes.breadCrumbWrapper}></Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            className={classes.header}
          >
            <Tab label={'Current'} />;
            <Tab label={'History'} />;

          </Tabs>
        </Box>

        <TabPanel value={value} index={0}>

          <div>
           
            <CurrentTerms studentId={studentId} />
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TermsHistory />
        </TabPanel>
      </Box> */}

      <Box>
        {/* <p>Attendance</p> */}
        <div className="cardlsitbox">
          <KenCard
            elevation={0}
            paperStyles={{
              padding: 16,
              paddingLeft: 0,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
            }}
          >
            <Box>
              <Box
                sx={{ borderBottom: 1, borderColor: 'divider' }}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  // padding: '0 25px',
                }}
              >
                <Tabs
                  style={{
                    padding: '0px',
                  }}
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  className={classes.tabs}
                >
                  <Tab
                    label="Current"
                    {...a11yProps(0)}
                    style={{ fontSize: '12px' }}
                  />
                  <Tab
                    label="History"
                    {...a11yProps(1)}
                    style={{ fontSize: '12px' }}
                  />
                </Tabs>
              </Box>
            </Box>
          </KenCard>
        </div>
        <TabPanel
          value={value}
          index={0}
          style={{ background: '#fff', minHeight: 320 }}
        >
          <CurrentTerms studentId={studentId} />
        </TabPanel>
        <TabPanel
          value={value}
          index={1}
          style={{ background: '#fff', minHeight: 320 }}
        >
          <TermsHistory />
        </TabPanel>
      </Box>
    </div>
  );
}

export default withRouter(StudentReport);

const ComponentsMarksTable = ({ data }) => {
  const columns = React.useMemo(
    () => [
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        Cell: ({ row }) => (
          // Use Cell to render an expander for each row.
          // We can use the getToggleRowExpandedProps prop-getter
          // to build the expander.
          <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? <AiFillCaretDown /> : <AiFillCaretRight />}
          </span>
        ),
      },
      {
        Header: 'Component',
        accessor: 'componentName',
      },
      {
        Header: 'Max Marks',
        accessor: 'maximumMarks',
      },
      {
        Header: 'Marks Obtained',
        accessor: 'marksObtained',
      },
      {
        Header: 'Marks In course',
        accessor: 'marksInCourse',
      },
    ],
    []
  );

  const renderRowSubComponent = React.useCallback(
    ({ row }) => <SubComponentsMarksTable data={row.original} />,
    []
  );

  return (
    <>
      {data?.componentList?.length > 0 ? (
        <Newtable
          columns={columns}
          data={data?.componentList}
          renderComponents={renderRowSubComponent}
        />
      ) : <p>No Data</p>}
    </>
  );
};

function SubComponentsMarksTable({ data }) {
  const [newData, setNewData] = useState([]);
  const columns = React.useMemo(
    () => [
      {
        Header: 'Sub Component',
        accessor: 'componentName',
        // render:(({value,row})=>(<a href={`${routes.studentsMarksBySubComponent}/${row?.original?.id}`} target="_blank">{value}</a>))
      },
      {
        Header: 'Max Marks',
        accessor: 'maximumMarks',
      },
      {
        Header: 'Marks Obtained',
        accessor: 'marksObtained',
      },
      {
        Header: 'Component Marks',
        accessor: 'marksComponent',
      },
      // {
      //   Header: 'Score Finalized',
      //   accessor: 'fianlized',
      // },
    ],
    []
  );
  useEffect(() => {
    const newData = [];
    let maximumMarks = data.maximumMarks;
    data?.subCompList.map((item) => {
      newData.push({ ...item, ['marksComponent']: maximumMarks });
    });
    setNewData(newData);
  }, []);
  return (
    <>
      {newData.length > 0 ? (
        <Newtable data={newData} columns={columns} />
      ) : (
        <p>No Data</p>
      )}
    </>
  );
}

function TermsHistory() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
  }));
  const classes = useStyles();

  return (
    <div className={classes.root} style={{ padding: '20px' }}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>Term 1</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box style={{ width: '100%' }}>
            <CurrentTerms />
          </Box>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Term 2</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box style={{ width: '100%' }}>
            <CurrentTerms />
          </Box>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Term 3</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box style={{ width: '100%' }}>
            <CurrentTerms />
          </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

function CurrentTerms({ studentId }) {
  // const { studentId } = props?.location?.state;
  const [data, setData] = React.useState([]);
  console.log(studentId);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    setLoading(true);
    getGradingDetailsByStudentId(studentId)
      .then((res) => {
        console.log(res);
        setData(res);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  }, []);

  const columns = React.useMemo(
    () => [
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        Cell: ({ row }) => (
          // Use Cell to render an expander for each row.
          // We can use the getToggleRowExpandedProps prop-getter
          // to build the expander.
          <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? <AiFillCaretDown /> : <AiFillCaretRight />}
          </span>
        ),
      },
      {
        Header: 'Subject',
        accessor: 'courseName',
      },
      {
        Header: 'Subject Code',
        accessor: 'courseId',
      },
      {
        Header: 'Course Credits',
        accessor: 'courseCredits',
      },
      {
        Header: 'Max',
        accessor: 'maximumMarks',
      },
      {
        Header: 'Obtained',
        accessor: 'marksObtained',
      },
      {
        Header: 'Percentage',
        accessor: 'percentage',
      },
      {
        Header: 'Grade',
        accessor: 'calculatedLetterGrade',
      },
      {
        Header: 'Final Grade',
        accessor: 'finalLetterGrade',
      },
      {
        Header: 'Status',
        accessor: 'passFailStatus',
      },
    ],
    []
  );
  const columns1 = React.useMemo(
    () => [
      {
        Header: 'Term Name',
        accessor: 'subjectName',
      },
      {
        Header: 'Type of Grade',
        accessor: 'subjectcode',
      },
      {
        Header: 'Number of backlogs',
        accessor: 'courseCredits',
      },
      {
        Header: 'Total credits Earned',
        accessor: 'maximumMarks',
      },
      {
        Header: 'Mandatory credits earned',
        accessor: 'marksObtained',
      },
      {
        Header: 'Elective credits earned',
        accessor: 'percentage',
      },
      {
        Header: 'Specialization credits earned',
        accessor: 'calculatedLetterGrade',
      },
      {
        Header: '% Obtained',
        accessor: 'finalLetterGrade',
      },
      {
        Header: 'Attendance %',
        accessor: 'passFailStatus',
      },
    ],
    []
  );

  const renderComponents = React.useCallback(
    ({ row }) => <ComponentsMarksTable data={row.original} />,
    []
  );

  const termDetails = [
    {
      Header: 'Term Name',
      accessor: 'Marketing',
    },
    {
      Header: 'Type of Grade',
      accessor: 'BBAMKT108',
    },
    {
      Header: 'Number of backlogs',
      accessor: '0',
    },
    {
      Header: 'Total credits Earned',
      accessor: '4',
    },
    {
      Header: 'Mandatory credits earned',
      accessor: '3',
    },
    {
      Header: 'Elective credits earned',
      accessor: '4.5',
    },
    {
      Header: 'Specialization credits earned',
      accessor: '3',
    },
    {
      Header: '% Obtained',
      accessor: '5',
    },
    {
      Header: 'Attendance %',
      accessor: '70',
    },
  ];

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ marginBottom: '20px' }}>
        {/* <Newtable
          columns={columns1}
          data={data}
        /> */}
        <Paper>
          <Grid container spacing={1}>
            {termDetails.map((term) => (
              <Grid item md={2}>
                <Box style={{ padding: '15px' }}>
                  <Typography
                    style={{ fontSize: '12px', paddingBottom: '10px' }}
                    color="textSecondary"
                  >
                    {' '}
                    {term.Header}
                  </Typography>
                  <Typography style={{ fontSize: '14px' }}>
                    {' '}
                    {term.accessor}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </div>

      <Newtable
        columns={columns}
        data={data}
        renderComponents={renderComponents}
      />
    </div>
  );
}
